import { Button, Form, Icon, Input, Tooltip } from 'antd'
import React from 'react'
import styled from 'styled-components/macro'

const ResetPasswordForm = ({
  submitEmailAddress,
  submitCodeAndPassword,
  form,
  user,
}) => {
  const { getFieldDecorator } = form
  const handleSubmit = e => {
    e.preventDefault()
    form.validateFields((err, values) => {
      if (!err) {
        if (!user.codeSent) {
          submitEmailAddress(values.email)
        } else {
          submitCodeAndPassword(values)
        }
      }
    })
  }
  return (
    <StyledFormWrapper>
      <StyledForm onSubmit={handleSubmit} className='login-form'>
        <Form.Item>
          <FieldLabel>Email Address</FieldLabel>
          {getFieldDecorator('email', {
            rules: [
              { required: true, message: 'Please input your email address' },
              { type: 'email', message: 'The input is not valid email' },
            ],
          })(
            <Input
              prefix={<StyledInputIcon type='user' />}
              placeholder='name@company.com'
              size='large'
            />,
          )}
        </Form.Item>

        {user.codeSent && (
          <>
            <Form.Item>
              <FieldLabel>Reset Code</FieldLabel>
              {getFieldDecorator('code', {
                rules: [
                  {
                    required: true,
                    message: 'Please enter your reset code',
                  },
                ],
              })(
                <Input
                  prefix={<StyledInputIcon type='safety-certificate' />}
                  type='text'
                  placeholder='Reset Code'
                  size='large'
                />,
              )}
            </Form.Item>
            <Form.Item>
              <FieldLabel>New Password</FieldLabel>
              {getFieldDecorator('password', {
                rules: [
                  {
                    required: true,
                    message: 'Please input your new password',
                  },
                ],
              })(
                <Input
                  prefix={<StyledInputIcon type='lock' />}
                  type='password'
                  placeholder='New Password'
                  size='large'
                />,
              )}
            </Form.Item>
          </>
        )}

        <Form.Item>
          <StyledSubmitButton
            type='primary'
            htmlType='submit'
            className='login-form-button'
          >
            {user.codeSent ? 'Reset Password' : 'Send Reset Code'}
          </StyledSubmitButton>
        </Form.Item>
        <Form.Item>
          <Tooltip
            placement='bottom'
            trigger='click'
            title='Passwords must contain, at least one number, one special character, one uppercase letter and one lowercase letter, and it must be 8 or more characters long.'
          >
            <TooltipHint>
              <Icon type='info-circle' />
              Password requirements
            </TooltipHint>
          </Tooltip>
        </Form.Item>
      </StyledForm>
    </StyledFormWrapper>
  )
}

const StyledFormWrapper = styled.div`
  width: 100%;
`

const StyledForm = styled(Form)`
  .ant-form-item {
    margin-bottom: 14px;
  }

  .ant-input-affix-wrapper .ant-input {
    border-radius: 8px;
  }
`

const FieldLabel = styled.span`
  display: block;
  margin-bottom: 6px;
  text-align: left;
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 0.01em;
  color: ${({ theme }) => theme.colours.seaweedGreen};
`

const StyledInputIcon = styled(Icon)`
  color: rgba(0, 0, 0, 0.32);
`

const StyledSubmitButton = styled(Button)`
  && {
    width: 100%;
    margin-bottom: 10px;
    font-weight: 600;
    border-radius: 8px;
    height: 42px;
  }
`

const TooltipHint = styled.span`
  cursor: pointer;
  color: ${({ theme }) => theme.colours.oliveGrey};
  font-size: 0.82rem;
  display: inline-flex;
  align-items: center;
  gap: 6px;
`

const WrappedNormalResetForm = Form.create({ name: 'reset' })(ResetPasswordForm)

export default WrappedNormalResetForm
